import type { OpenAccountResponseDto } from '../api/types';
import { OpenAccountResultDetails } from '../ui/OpenAccountResultDetails';
import { ResultContent } from '@/shared/components';
import { useTranslation } from 'react-i18next';
import { ModalComponentWrapper } from '@/shared/components';
import { useModalStore } from '@/shared/lib';
import { secondsToMinutes } from '@/shared/utils';

const useOpenAccountResult = () => {
  const { showDialogComponent, closeDialog } = useModalStore();
  const { t } = useTranslation();

  const goToSuccessScreen = (
    openAccountData: OpenAccountResponseDto | undefined
  ) => {
    if (!openAccountData) return;
    const minutes = secondsToMinutes(openAccountData.openingTimeout);
    showDialogComponent({
      component: (
        <ModalComponentWrapper>
          <ResultContent
            isSuccess
            onClick={() => {
              closeDialog();
            }}
            title={t('openAccount.successTitle')}
            description={t('openAccount.successDescription', {
              count: minutes,
            })}
            buttonText={t('common.finish')}
            buttonVariant="default"
            className="h-auto">
            <OpenAccountResultDetails openAccountData={openAccountData} />
          </ResultContent>
        </ModalComponentWrapper>
      ),
    });
  };

  const goToErrorScreen = () => {
    showDialogComponent({
      component: (
        <ModalComponentWrapper>
          <ResultContent
            isSuccess={false}
            onClick={() => {
              closeDialog();
            }}
            title={t('openAccount.errorTitle')}
            description={t('openAccount.errorDescription')}
            buttonText={t('common.close')}
          />
        </ModalComponentWrapper>
      ),
    });
  };

  return {
    goToSuccessScreen,
    goToErrorScreen,
  };
};

export { useOpenAccountResult };
